import React from 'react';
import classNames from 'classnames';

import { Tag } from '@uncinc/uncinc-react-kitchen-sink';
import type { TagProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Tag';

import './style.scss';

export interface TagItem extends Pick<TagProps, 'iconName' | 'className'> {
  name: string;
  type?: string;
}

declare interface TagsProps {
  items: TagItem[];
}

const Tags: React.FC<TagsProps> = ({ items }: TagsProps) => (
  <div className="Tags">
    {items.map((item) => (
      <Tag
        name={item.name}
        iconName={item.iconName}
        className={classNames(
          item.name.replace(' ', '_'),
          item.type,
          item.className,
        )}
      />
    ))}
  </div>
);

export default Tags;
